import { buttonVariants } from "@/design-system/Button";
import { twResolve } from "@/helpers/tw-resolve";
import { useTranslation } from "@/translations";

import type { GroupIconType } from "./GroupIcon";
import { GROUP_ICONS, GroupIcon } from "./GroupIcon";

interface GroupIconPickerProps {
  onChange: (icon: GroupIconType) => void;
  selectedIcon: GroupIconType | null;
}

export function GroupIconPicker({ onChange, selectedIcon }: GroupIconPickerProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <section className="grid w-full grid-cols-control-fill grid-rows-control-fill justify-center gap-space-sm">
      {GROUP_ICONS.map((icon) => {
        const isSelected = selectedIcon === icon;

        return (
          <button
            type="button"
            key={icon}
            className={twResolve(
              buttonVariants({ variant: "outline", size: "md", inset: "compact", content: "icon" }),
              "size-control-md",
              isSelected ? "border-border-brand bg-background-brand-light" : "border-border-secondary",
            )}
            aria-label={t("component.group-icon-picker-input.named-option-label", { icon })}
            aria-pressed={isSelected}
            data-testid="icon-action-select"
            onClick={() => {
              onChange(icon);
            }}
          >
            <GroupIcon size={24} icon={icon} />
          </button>
        );
      })}
    </section>
  );
}
